import { useState } from "react";

export default function ModalBasic(props: PropsModalBasic) {
  function toggleModal() {
    props.setStateModal(!props.open);
  }

  let classToggleModal = props.open ? "" : "hidden";
  let widthClases = props.widthClases
    ? props.widthClases
    : "w-full max-w-2xl md:max-w-4xl lg:max-w-6xl";

  const footer = props.footer ? (
    <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600 text-white">
      {props.footer}
      {/* <button
                type="button"
                className="text-white bg-teal-700 hover:bg-teal-800 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-teal-600 dark:hover:bg-teal-700 dark:focus:ring-teal-800"
                >
                I accept
                </button>
                <button
                type="button"
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                >
                Decline
              </button> */}
    </div>
  ) : (
    ""
  );

  return (
    <>
      {/* <!-- Main modal --> */}
      <div
        id="defaultModal"
        tabIndex={-1}
        aria-hidden="true"
        className={
          "no-scrollbar overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-full bg-gray-600/60 flex justify-center items-center max-h-screen " +
          classToggleModal
        }
      >
        <div
          className={"relative p-4 z-50 " + widthClases}
          style={{ maxHeight: "95vh" }}
        >
          {/* <!-- Modal content --> */}
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            {/* <!-- Modal header --> */}
            <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600">
              <h3 className="text-2xl font-semibold text-gray-900 dark:text-white uppercase">
                {props.title}
              </h3>
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={toggleModal}
              >
                <svg
                  aria-hidden="true"
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            {/* <!-- Modal body --> */}
            <div className="p-6 space-y-6 text-white">
              {props.open ? props.children : ""}
            </div>
            {/* <!-- Modal footer --> */}
            {footer}
          </div>
        </div>
      </div>
    </>
  );
}

interface PropsModalBasic {
  open: boolean;
  setStateModal: Function;
  title: string;
  widthClases?: string;
  children: JSX.Element;
  footer?: JSX.Element;
}
